import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { IQuizCurrentState, IQuizState } from ".";
import { now } from "../../utils/time";
import { parseQuizCooldownAllowDate } from "../../utils/quiz-task";
import { setQuizTaskAllowDate } from "../tasks";

export interface IStartQuizResponse extends IQuizCurrentState {};

export interface IStartQuizCooldownPayload {
    allowDate: number;
}

export const startQuiz = createAsyncThunk<IStartQuizResponse, number, { rejectValue: IStartQuizCooldownPayload }>(
    'quiz.startQuiz',
    async (interestId: number, { rejectWithValue, dispatch }) => {
        try {
            return await api.quizzes.start(interestId);
        }
        catch (error: unknown) {
            const allowDate = parseQuizCooldownAllowDate(error);
            if (allowDate !== undefined) {
                dispatch(setQuizTaskAllowDate(allowDate));
                return rejectWithValue({ allowDate });
            }

            throw error;
        }
    }
);

const startQuizHandler = (builder: ActionReducerMapBuilder<IQuizState>) => {
    builder
        .addCase(startQuiz.pending, (state: IQuizState) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(startQuiz.fulfilled, (state: IQuizState, action: PayloadAction<IStartQuizResponse>) => {
            state.loading = false;            
            state.quiz = action.payload;

            if (state.quiz)
                state.deltaTime = now() - state.quiz.now;
        })
        .addCase(startQuiz.rejected, (state: IQuizState, action) => {
            state.loading = false;
            if (action.payload)
                state.error = '';
            else
                state.error = 'Unable to start quiz';
        });
};

export default startQuizHandler;
